export const PrivacyInformationTestIds = {
  privacyHeader: 'privacy_header'
} as const;
